export const queryParams = (params = {}) => {
  if (typeof params !== 'object') {
    throw Error('you need to pass object');
  }
  let query = '?';
  const paramKeys = Object.keys(params);

  paramKeys.map((key, index) => {
    if (params[key] === undefined || params[key] === 'undefined') {
      return;
    }
    if (paramKeys.length === index + 1) {
      query += `${key}=${params[key]}`;
      return;
    }
    query += `${key}=${params[key]}&`;
  });
  return query;
};



// WEBPACK FOOTER //
// ./app/lib/queryParams.js